

















import {Component, Prop, Vue} from "vue-property-decorator";
import {CustomerRegister} from "@/interfaces/entity";
import {CustomerRegisterStore} from "../../store";

@Component({
    name: "CustomerRegisterTableAction"
})
export default class extends Vue {
    @Prop({ required: true, type: Number })
    readonly id!: number;
    
    get customerRegister(): CustomerRegister {
        return CustomerRegisterStore.data[this.id];
    }
    
    set customerRegister(value: CustomerRegister) {
        CustomerRegisterStore.data[this.id] = value;
    }
    async onConfirm() {
        try {
            console.log("xoa")
            await CustomerRegisterStore.deleteCustomerRegister(this.id);
            this.$notification.success({
                message: "Thành công",
                description: "Xóa thành công"
            });
        } catch (e) {
            this.$notification.error({
                message: "Thất bại",
                description: "Xóa thất bại"
            });
        }
    }
}
